import { render } from "./switch.vue?vue&type=template&id=682d1edd"
const script = {}

import exportComponent from "C:\\Users\\wjlfi\\Desktop\\1v1vue3\\demos\\basic\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__